if (!customElements.get('tag-filter')) {
  customElements.define(
    'tag-filter',
    class TagFilter extends HTMLSelectElement {
      constructor() {
        super();
    
        this.updateWidth();
        this.addEventListener('change', this.onChange);
      }
    
      updateWidth() {
        const value = this.options[this.selectedIndex].text;
        const width = theme.getElementWidth(this, value);
        this.style.setProperty('--width', `${width}px`);
      }
    
      onChange() {
        this.updateWidth();
        window.location.href = this.value;
      }
    }, { extends: 'select' }
  );
}

if (!customElements.get('multiselect-tag-filter')) {
  customElements.define(
    'multiselect-tag-filter',
    class MultiSelectTagFilter extends HTMLElement {
      constructor() {
        super();
        
        this.button = this.querySelector('.multiselect-button');
        this.dropdown = this.querySelector('.multiselect-dropdown');
        this.checkboxes = this.querySelectorAll('input[type="checkbox"]');
        this.applyButton = this.querySelector('.apply-filters');
        this.clearButton = this.querySelector('.clear-filters');
        this.selectedCount = this.querySelector('.selected-count');
        
        this.blogUrl = this.dataset.blogUrl;
        this.isOpen = false;
        
        this.init();
      }
      
      init() {
        // Toggle dropdown
        this.button.addEventListener('click', (e) => {
          e.stopPropagation();
          this.toggleDropdown();
        });
        
        // Close dropdown when clicking outside
        document.addEventListener('click', (e) => {
          if (this.isOpen && !this.contains(e.target)) {
            this.closeDropdown();
          }
        });
        
        // Update selected count when checkboxes change
        this.checkboxes.forEach(checkbox => {
          checkbox.addEventListener('change', () => this.updateSelectedCount());
        });
        
        // Apply filters
        this.applyButton.addEventListener('click', () => this.applyFilters());
        
        // Clear all filters
        this.clearButton.addEventListener('click', () => this.clearFilters());
        
        // Initialize count
        this.updateSelectedCount();
      }
      
      toggleDropdown() {
        this.isOpen = !this.isOpen;
        this.dropdown.classList.toggle('hidden', !this.isOpen);
        this.button.setAttribute('aria-expanded', this.isOpen);
      }
      
      closeDropdown() {
        this.isOpen = false;
        this.dropdown.classList.add('hidden');
        this.button.setAttribute('aria-expanded', 'false');
      }
      
      updateSelectedCount() {
        const count = Array.from(this.checkboxes).filter(cb => cb.checked).length;
        this.selectedCount.textContent = count > 0 ? `(${count})` : '';
      }
      
      applyFilters() {
        const selectedTags = Array.from(this.checkboxes)
          .filter(cb => cb.checked)
          .map(cb => cb.value);
        
        if (selectedTags.length === 0) {
          window.location.href = this.blogUrl;
        } else {
          const tagString = selectedTags.join('+');
          window.location.href = `${this.blogUrl}/tagged/${tagString}`;
        }
      }
      
      clearFilters() {
        this.checkboxes.forEach(cb => cb.checked = false);
        this.updateSelectedCount();
        window.location.href = this.blogUrl;
      }
    }
  );
}

// Client-side filtering for blog-posts section
if (!customElements.get('blog-tag-filter-posts')) {
  customElements.define(
    'blog-tag-filter-posts',
    class BlogTagFilterPosts extends HTMLElement {
      constructor() {
        super();
        
        this.button = this.querySelector('.multiselect-button');
        this.dropdown = this.querySelector('.multiselect-dropdown');
        this.checkboxes = this.querySelectorAll('input[type="checkbox"]');
        this.applyButton = this.querySelector('.apply-filters');
        this.clearButton = this.querySelector('.clear-filters');
        this.selectedCount = this.querySelector('.selected-count');
        this.sectionId = this.dataset.sectionId;
        
        this.isOpen = false;
        
        this.init();
      }
      
      init() {
        // Toggle dropdown
        this.button.addEventListener('click', (e) => {
          e.stopPropagation();
          this.toggleDropdown();
        });
        
        // Close dropdown when clicking outside
        document.addEventListener('click', (e) => {
          if (this.isOpen && !this.contains(e.target)) {
            this.closeDropdown();
          }
        });
        
        // Update selected count when checkboxes change
        this.checkboxes.forEach(checkbox => {
          checkbox.addEventListener('change', () => this.updateSelectedCount());
        });
        
        // Apply filters
        this.applyButton.addEventListener('click', () => this.applyFilters());
        
        // Clear all filters
        this.clearButton.addEventListener('click', () => this.clearFilters());
        
        // Initialize count
        this.updateSelectedCount();
      }
      
      toggleDropdown() {
        this.isOpen = !this.isOpen;
        this.dropdown.classList.toggle('hidden', !this.isOpen);
        this.button.setAttribute('aria-expanded', this.isOpen);
      }
      
      closeDropdown() {
        this.isOpen = false;
        this.dropdown.classList.add('hidden');
        this.button.setAttribute('aria-expanded', 'false');
      }
      
      updateSelectedCount() {
        const count = Array.from(this.checkboxes).filter(cb => cb.checked).length;
        this.selectedCount.textContent = count > 0 ? `(${count})` : '';
      }
      
      applyFilters() {
        const selectedTags = Array.from(this.checkboxes)
          .filter(cb => cb.checked)
          .map(cb => cb.value);
        
        // Get all article items in this section
        const sliderElement = document.querySelector(`#Slider-${this.sectionId}`);
        if (!sliderElement) return;
        
        const articles = sliderElement.querySelectorAll('.blog-post-item');
        
        articles.forEach(article => {
          const articleTags = article.dataset.articleTags ? article.dataset.articleTags.split(',') : [];
          
          if (selectedTags.length === 0) {
            // No filters, show all
            article.style.display = '';
          } else {
            // Check if article has ANY of the selected tags
            const hasMatchingTag = selectedTags.some(tag => articleTags.includes(tag));
            article.style.display = hasMatchingTag ? '' : 'none';
          }
        });
        
        this.closeDropdown();
      }
      
      clearFilters() {
        this.checkboxes.forEach(cb => cb.checked = false);
        this.updateSelectedCount();
        
        // Show all articles
        const sliderElement = document.querySelector(`#Slider-${this.sectionId}`);
        if (sliderElement) {
          const articles = sliderElement.querySelectorAll('.blog-post-item');
          articles.forEach(article => {
            article.style.display = '';
          });
        }
        
        this.closeDropdown();
      }
    }
  );
}
